import { useI18n } from "../../i18n/I18nContext";

import Style from "./LanguageSwitcher.module.css";

const languages = ["en", "bg"];

const LanguageSwitcher = ({ className = "" }) => {
  const { language, setLanguage, copy } = useI18n();

  return (
    <div
      className={`${Style.switcher} ${className}`.trim()}
      role="group"
      aria-label={copy.common.languageSelectorLabel}
    >
      {languages.map((languageCode) => (
        <button
          key={languageCode}
          type="button"
          className={
            language === languageCode ? Style["switcher__button--active"] : ""
          }
          aria-label={copy.common.languageNames[languageCode]}
          aria-pressed={language === languageCode}
          onClick={() => setLanguage(languageCode)}
        >
          {languageCode.toUpperCase()}
        </button>
      ))}
    </div>
  );
};

export default LanguageSwitcher;
